import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Sidebar.css';
import IjsselSmallIcon from '../../logos_images/Ijs_logo_small_no_background.png'

import {
    Drawer,
    Typography,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Switch,
    FormControlLabel,
    Slider,
    Button,
} from '@mui/material';

function Sidebar({ resetMessages, isOpen, toggleSidebar, isSimplifiedMode, setIsSimplifiedMode, variant }) {
    const { t, i18n } = useTranslation();
    const [fontSize, setFontSize] = useState(18);

    const handleFontSizeChange = (e, newValue) => {
        setFontSize(newValue);
        document.documentElement.style.setProperty('--base-font-size', `${newValue}px`);
    };

    const handleLanguageChange = (e) => {
        const selectedLanguage = e.target.value;
        i18n.changeLanguage(selectedLanguage);
    };

    const handleLanguageModeChange = (event) => {
        setIsSimplifiedMode(event.target.checked);
    };

    const isRTL = i18n.language === 'arabic';

    return (
        <Drawer
            variant={variant} // Use the variant passed as a prop
            anchor="left"
            open={isOpen}
            onClose={toggleSidebar} // Enable closing in temporary mode
            sx={{
                width: 280,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: 280,
                    boxSizing: 'border-box',
                    backgroundColor: 'var(--sidebar-background-color)',
                    pt: 5,
                    pl: 4,
                    pr: 4
                },
            }}
        >
            <Box textAlign="center" mb={1} sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}} component="header">
                <Typography
                    component="h1"
                    variant="h5"
                    sx={{color: '#025359', fontWeight: 'bold', pb: 4}}
                    dir={isRTL ? 'rtl' : 'ltr'}
                >
                    {t('sidebar.title')}
                </Typography>
            </Box>

            <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom:'15px'}}>
                <img src={IjsselSmallIcon} alt="logo IJsselgemeenten" style={{width: '80px', marginLeft: '1px', marginBottom: '5px'}} />
            </Box>

            <Box textAlign="center" mb={5}>
                <Typography
                    variant="p"
                    sx={{color: '#025359', fontWeight: 'bold', pb: 10, fontSize: `${fontSize * 0.8}px`}}
                    dir={isRTL ? 'rtl' : 'ltr'}
                >
                    {t('sidebar.intro')}
                </Typography>
            </Box>

            <Box mb={1}>
                {/* Language Selection */}
                <FormControl fullWidth margin="normal" variant="outlined">
                    <InputLabel id="language-select-label" dir={isRTL ? 'rtl' : 'ltr'}>
                        {t('sidebar.languageLabel')}
                    </InputLabel>
                    <Select
                        labelId="language-select-label"
                        id="language-select"
                        value={i18n.language}
                        onChange={handleLanguageChange}
                        label={t('sidebar.languageLabel')}
                        aria-label={t('sidebar.languageLabel')}
                        sx={{
                            backgroundColor: '#ffffff',
                            color: '#000000',
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#000000',
                                borderStyle: 'dashed',
                                borderWidth: '4px',
                            },
                            '& .MuiSelect-select:focus': {
                                backgroundColor: '#ffffff',
                                color: '#000000',
                            },
                        }}
                        MenuProps={{
                            MenuListProps: {
                                sx: {
                                    /* Remove default blue highlight and use our own */
                                    '& .MuiMenuItem-root.Mui-selected': {
                                        backgroundColor: '#f0f0f0 !important',
                                        color: '#000000',
                                    },
                                    '& .MuiMenuItem-root.Mui-focusVisible, & .MuiMenuItem-root:hover': {
                                        backgroundColor: '#000000 !important',
                                        color: '#ffffff',
                                    },
                                },
                            },
                        }}
                    >
                        <MenuItem
                            value="dutch"
                            sx={{
                                '&.Mui-selected': {
                                    backgroundColor: '#f0f0f0',
                                    color: '#000000',
                                },
                                '&:hover, &.Mui-focusVisible': {
                                    backgroundColor: '#000000',
                                    color: '#ffffff',
                                },
                            }}
                        >
                            {t('sidebar.languageOptions.dutch')}
                        </MenuItem>
                        <MenuItem
                            value="english"
                            sx={{
                                '&.Mui-selected': {
                                    backgroundColor: '#f0f0f0',
                                    color: '#000000',
                                },
                                '&:hover, &.Mui-focusVisible': {
                                    backgroundColor: '#000000',
                                    color: '#ffffff',
                                },
                            }}
                        >
                            {t('sidebar.languageOptions.english')}
                        </MenuItem>
                        <MenuItem
                            value="arabic"
                            sx={{
                                '&.Mui-selected': {
                                    backgroundColor: '#f0f0f0',
                                    color: '#000000',
                                },
                                '&:hover, &.Mui-focusVisible': {
                                    backgroundColor: '#000000',
                                    color: '#ffffff',
                                },
                            }}
                        >
                            {t('sidebar.languageOptions.arabic')}
                        </MenuItem>
                    </Select>
                </FormControl>

                {/*
                <Box sx={{ mt: 2, pb:4 , pl:1}} >
                    <Typography variant="subtitle1" gutterBottom id="language-mode-label">
                        {t('sidebar.languageModeLabel')}
                    </Typography>

                    <Box display="flex" textAlign='center' alignItems="center" justifyContent="center">
                        <Typography variant="body2" sx={{ mr: 2 }} id="regular-mode-label">
                            {t('sidebar.languageModes.regular')}
                        </Typography>

                        <FormControlLabel
                            control={
                                <Switch
                                    size="medium"
                                    checked={isSimplifiedMode}
                                    onChange={handleLanguageModeChange}
                                    aria-labelledby="language-mode-label"
                                    aria-label={t('sidebar.languageModes.simplified')}
                                    sx={{
                                        width: 90,
                                        height: 38,
                                        padding: 1,
                                        '& .MuiSwitch-switchBase': {
                                            padding: 0,
                                            '&.Mui-checked': {
                                                transform: 'translateX(56px)',
                                                '& .MuiSwitch-thumb': {
                                                    backgroundColor: '#00796B', // Dark teal thumb when checked
                                                },
                                                '& + .MuiSwitch-track': {
                                                    backgroundColor: 'var(--primary-color)', // Teal track when checked
                                                },
                                            },
                                        },
                                        '& .MuiSwitch-thumb': {
                                            width: 30,
                                            height: 30,
                                            transform: 'translateY(4px)',
                                            backgroundColor: 'var(--white-color)', // White thumb when unchecked
                                        },
                                        '& .MuiSwitch-track': {
                                            borderRadius: 10,
                                            opacity: 1,
                                            backgroundColor: 'var(--switch-background)', // Light teal track when unchecked
                                        },
                                    }}
                                />
                            }
                            label={
                                <Typography variant="body2" sx={{ ml: 1 }} id="simplified-mode-label">
                                    {t('sidebar.languageModes.simplified')}
                                </Typography>
                            }
                            labelPlacement="end"
                        />
                    </Box>
                </Box>
                */}
                {/* Clear Memory Button */}

            </Box>
            <Box textAlign='center'>
                <Button
                    fullWidth
                    variant="contained"
                    aria-label={t('sidebar.clearMemoryIntro')} // Add aria-label for screen readers
                    sx={{
                        mt: 1,
                        pb: 2,
                        backgroundColor: 'var(--primary-color)',  // Teal color
                        color: 'var(--white-color)',         // Button text color
                        borderRadius: 'var(--button-border-radius)',
                        padding: '10px 0',
                        fontWeight: 'bold',
                        textTransform: 'none', // Prevent text from being capitalized
                        '&:hover': {
                            backgroundColor: 'var(--light-teal-color)',  // Lighter teal color on hover
                        },
                    }}
                    onClick={resetMessages}
                    dir={isRTL ? 'rtl' : 'ltr'}
                >
                    {t('sidebar.clearMemoryIntro')}
                </Button>

            </Box>
            <Box>
                {/* Font Size Selection */}
                <Box mt={3} textAlign='center'>
                    {/* Font Size Label */}
                    <Typography gutterBottom dir={isRTL ? 'rtl' : 'ltr'} id="font-size-label">
                        {t('sidebar.fontSizeLabel')}
                    </Typography>

                    {/* Slider with side labels */}
                    <Box display="flex" alignItems="center">
                        <Typography variant="body2" sx={{mr: 1, fontSize: `${fontSize}px` }}>a</Typography>

                        <Slider
                            value={fontSize}
                            onChange={handleFontSizeChange}
                            aria-labelledby="font-size-label" // Associates the slider with a label
                            min={14}
                            max={44}
                            sx={{
                                color: 'var(--primary-color)', // Teal color for slider track in normal state
                                '& .MuiSlider-thumb': {
                                    width: 20,
                                    height: 20,
                                },
                                /* High-contrast focus for keyboard users */
                                '& .MuiSlider-thumb:focus-visible, & .MuiSlider-thumb.Mui-focusVisible': {
                                    outline: '3px dashed #000000',
                                    outlineOffset: '4px',
                                    boxShadow: 'none',
                                    backgroundColor: '#ffffff',
                                    border: '2px solid #000000',
                                },
                                '& .MuiSlider-root:focus-visible .MuiSlider-thumb': {
                                    outline: '3px dashed #000000',
                                    outlineOffset: '4px',
                                    boxShadow: 'none',
                                    backgroundColor: '#ffffff',
                                    border: '2px solid #000000',
                                },
                            }}
                        />

                        <Typography variant="body2" sx={{ ml: 1, fontSize: `${fontSize * 2}px` }}>a</Typography>
                    </Box>
                </Box>
            </Box>
        </Drawer>
    );
}

export default Sidebar;
